import arrayIncludes from 'core-js/es/array/virtual/includes'
import stringIncludes from 'core-js/es/string/virtual/includes'
import arrayFind from 'core-js/es/array/virtual/find'
import 'core-js/es/set'
import 'intersection-observer'

Array.prototype.includes = arrayIncludes
String.prototype.includes = stringIncludes
Array.prototype.find = arrayFind
